import React, { PropsWithChildren } from 'react'

import { ContainerProps } from './Container.props'

import { ContainerContent } from './Container.styled'

const Container = ({
  children,
  size,
  style,
}: PropsWithChildren<Record<string, unknown>> & ContainerProps) => {
  return (
    <ContainerContent size={size} style={style}>
      {children}
    </ContainerContent>
  )
}

export default Container
